import IFOOrder from './IFOOrder';

export default IFOOrder;
